<template lang="pug">
#CompletarPrecompletada
  b-button(
    variant="action"
    @click="showModalCotizacionNew()"
  )
    | Completar Cotización
  ModalCotizacionNew(:dataOv="dataOv" :modalId="modalId" @close="onClose" quotationType="update")
</template>
<script>
import ModalCotizacionNew from '../../ModalCotizacionNew.vue';

export default {
  name: 'CompletarPrecompletada',
  components: {
    ModalCotizacionNew
  },
  props: {
    dataOv: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      showModal: false,
      modalId: `modal-cotization-completo-${this._uid}` // eslint-disable-line no-underscore-dangle
    }
  },
  watch: {
    showModal() {
      console.log(this.dataOv);
    }
  },
  methods: {
    showModalCotizacionNew() {
      this.showModal = true;
      this.$bvModal.show(this.modalId);
    },
    onClose() {
      this.$emit('reloadAll');
      this.showModal = false;
    }
  }
}
</script>
